import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "semantic-ui-less/semantic.less";
import "typeface-muli";
import { ToastProvider } from "react-toast-notifications";
import { Provider } from "react-redux";
import configureStore from "./redux/config-store";
import { initialState } from "./redux/root-initital-state";
import ToastMessages from "./geofence/components/ToastMessages";
import { GoogleOAuthProvider } from "@react-oauth/google";
const store = configureStore(initialState);

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider
      components={{ Toast: ToastMessages }}
      placement="bottom-center"
      autoDismiss
      autoDismissTimeout={2500}
    >
      <GoogleOAuthProvider clientId="729529409177-e1a81kvaugkuu2eto6oi8gfdcmcb7oaq.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
    </ToastProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
